import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, testid, tone = "light" }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] ${
      tone === "dark" ? "text-[#cbb890]" : "text-[#9c7a33]"
    }`}
  >
    <span
      className={`h-2 w-2 border ${
        tone === "dark" ? "border-[#cbb890]" : "border-[#9c7a33]"
      }`}
    />
    {children}
  </span>
);
